import momentTz from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate, injectIntl, intlShape } from 'react-intl';
import { Avatar } from 'shared-components/image/avatar';

export const InboxMessagePanel = injectIntl(({ from, body, created, intl }) => {
  const zone = momentTz.tz.guess();
  const time = momentTz.tz(created, zone).format('LT z');
  const formattedTime = intl.formatTime(moment(time, 'LT'));

  return (
    <div data-testing-id='message-panel'>
      <div className='message-panel-row flex'>
        <div className='message-panel-avatar-wrap'>
          <Avatar id={from.avatar_id} />
        </div>
        <div className='flex-1'>
          <p
            style={{ whiteSpace: 'pre-wrap', 'overflow-wrap': 'break-word' }}
            data-testing-id='message-body'
          >
            {body}
          </p>
          <p className='text-gray text-small' data-testing-id='message-date'>
            <FormattedDate
              value={created}
              year='numeric'
              month='short'
              day='numeric'
              weekday='short'
            />{' '}
            {formattedTime}
          </p>
        </div>
      </div>
      <hr />
    </div>
  );
});

InboxMessagePanel.propTypes = {
  from: PropTypes.object,
  body: PropTypes.string,
  created: PropTypes.string,
  intl: intlShape
};
